import {Close, Search} from '@material-ui/icons';
import {useEffect, useState} from 'react';
import {Language} from '../../../context/LanguageContext';
import {
  CheckBoxPkCodeSelection,
  CheckBoxSelection,
  Dropdown,
} from '../../../components';
import {Grid} from '@material-ui/core';
import {useUser} from '../../../hooks';
import Cookies from 'js-cookie';
import {AddCircleIcon, IconProfile} from '../../../assets';
import {Button} from '@mui/material';
export default function FormAppAuth({onClose, data}) {
  const [step, setStep] = useState(1);
  const [search, setSearch] = useState('');
  const [searchKawasan, setSearchKawasan] = useState('');
  const [userList, setUserList] = useState([]);
  const [kawasanList, setKawasanList] = useState([]);
  const [authorizationList, setAuthorizationList] = useState([]);
  const [selected, setSelected] = useState({});
  const {language, newObj} = Language();
  const tokens_session = Cookies.get('token');
  const [payload, setPayload] = useState({
    assigned_username: '',
    authorization: [],
    pk_codes: [],
  });
  const {
    getApplicationUnauthorizationList,
    getPPPLSAllKawasan,
    getPPPLSAuthorization,
    createApplicationAuthorization,
  } = useUser();
  const handleSubmit = async (tokens_session, payload) => {
    try {
      const response = await createApplicationAuthorization(
        tokens_session,
        payload
      );
      onClose();
    } catch (error) {}
  };
  const handleGetAppUnauthList = async (tokens_session, payload) => {
    try {
      const response = await getApplicationUnauthorizationList(
        tokens_session,
        payload
      );
      setUserList(response.data.data || []);
    } catch (error) {}
  };
  const handleGetAppAuthKawasanAuthorization = async (tokens_session) => {
    try {
      const responseKawasan = await getPPPLSAllKawasan(tokens_session, {
        q: searchKawasan,
      });
      const responseAuthorization = await getPPPLSAuthorization(tokens_session);
      setKawasanList(responseKawasan.data.data);
      setAuthorizationList(responseAuthorization.data.data);
    } catch (error) {}
  };
  const searchGetPPPLSAllKawasan = async (tokens_session, payload) => {
    try {
      const response = await getPPPLSAllKawasan(tokens_session, payload);
      setKawasanList(response.data.data);
    } catch (error) {
      console.error('Error fetching kawasan:', error);
    }
  };
  const splitOnce = (str) => {
    const spaceIndex = str.indexOf(' ');
    if (spaceIndex === -1) return [str]; // No space found
    return [str.substring(0, spaceIndex), str.substring(spaceIndex + 1)];
  };
  const handleChangeCheckAuthorization = (e) => {
    const {name, value, checked} = e.target;
    if (value === 'HQ' && checked) {
      return setPayload((prev) => ({
        ...prev,
        [name]: [authorizationList.find((item) => item === value)],
        pk_codes: [],
      }));
    } else if (value === 'HQ' && !checked) {
      return setPayload((prev) => ({
        ...prev,
        [name]: [],
        pk_codes: [],
      }));
    }
    const kawasanName = splitOnce(value)[1];
    const chosenKawasan = kawasanList.filter(
      (item) => item.namaNegeri === kawasanName
    );
    if (checked) {
      if (payload.authorization.includes('HQ')) {
        return setPayload((prev) => ({
          ...prev,
          [name]: [...prev[name].filter((item) => item !== 'HQ'), value],
        }));
      }
      setPayload((prev) => ({
        ...prev,
        [name]: [...prev[name], value],
      }));
    } else {
      setPayload((prev) => ({
        ...prev,
        [name]: prev[name].filter((item) => item !== value),
      }));
    }
  };

  const handleChangeCheckPkCode = (e, obj) => {
    const {name, checked} = e.target;
    if (checked) {
      setPayload((prev) => ({
        ...prev,
        [name]: [...prev[name], obj.kodKawasan],
      }));
    } else {
      if (
        payload.authorization.find(
          (auth) => splitOnce(auth)[1] === obj.namaNegeri
        )
      ) {
        return setPayload((prev) => ({
          ...prev,
          [name]: prev[name].filter((item) => item !== obj.kodKawasan),
          authorization: prev.authorization.filter(
            (auth) => splitOnce(auth)[1] !== obj.namaNegeri
          ),
        }));
      }
      setPayload((prev) => ({
        ...prev,
        [name]: prev[name].filter((item) => item !== obj.kodKawasan),
      }));
    }
  };

  useEffect(() => {
    if (data.selected.type === 'add') {
      handleGetAppUnauthList(tokens_session, {q: search});
    }
    if (data.selected.type === 'edit') {
      setStep(2);
      setSelected(data.selected);
      setPayload((prev) => ({
        ...prev,
        assigned_username: data.selected.username,
        authorization: data.selected.pengesahanAplikasi,
        pk_codes: data.selected.pengesahanAplikasiKawasan,
      }));
    }
    handleGetAppAuthKawasanAuthorization(tokens_session);
  }, []);

  return (
    <div className='modal_content center app_auth'>
      <div className='modal_header'>
        <p className='modal_title'>
          {newObj.TaskReportAuthorizationWord[language]}
        </p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className='modal_body'>
        {step === 1 && (
          <>
            <form
              action='POST'
              className='app_auth_search_form'
              onSubmit={(e) => {
                e.preventDefault();
                handleGetAppUnauthList(tokens_session, {q: search});
              }}
            >
              <div className='app_auth_search_input_wrapper'>
                <input
                  type='text'
                  value={search}
                  className='app_auth_search_input'
                  onChange={(e) => setSearch(e.target.value)}
                />
                <Search className='app_auth_search_icon' />
              </div>
            </form>
            <Grid container className='app_auth_search_selection_wrapper'>
              <CheckBoxSelection
                data={userList}
                onSelectionChange={(item) => {
                  setSelected(item);
                }}
                isOneSelection={true}
                selected={selected}
                name='user'
              />
            </Grid>
            <div className='modal_flexible_btn_ctr'>
              <button
                onClick={() => {
                  setStep(2);
                  setPayload((prev) => ({
                    ...prev,
                    assigned_username: selected.username,
                  }));
                }}
              >
                {newObj.NextWord[language]}
              </button>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div className='app_auth_selected_user'>
              <div className='left'>
                <div className='app_auth_selected_user_info'>
                  <img
                    src={selected.avatar || IconProfile}
                    alt={selected.name}
                    className='app_auth_selected_user_avatar'
                  />
                  <div className='app_auth_selected_user_text'>
                    <div className='top_text'>
                      {selected.firstname} {selected.lastname}
                    </div>
                    <div className='bottom_text'>{selected.username}</div>
                  </div>
                </div>
                <div className='app_auth_pk_code_list'>
                  {kawasanList?.map((item) =>
                    payload.pk_codes.includes(item.kodKawasan) ? (
                      <div className='pk_code_item'>
                        {item.kodKawasan} | {item.namaKawasan}
                      </div>
                    ) : null
                  )}
                </div>
              </div>
              <div className='right'>
                <div className='banner_blue'>Authorization</div>
                <div className='list_choice'>
                  {authorizationList.map((authorization) => (
                    <div className='item_choice' key={authorization}>
                      <input
                        type='checkbox'
                        name='authorization'
                        id={authorization}
                        value={authorization}
                        onChange={handleChangeCheckAuthorization}
                        checked={payload?.authorization?.includes(
                          authorization
                        )}
                      />
                      <label htmlFor={authorization}>{authorization}</label>
                    </div>
                  ))}
                </div>
                <Button className='btn_pk_code' onClick={() => setStep(3)}>
                  <img src={AddCircleIcon} alt='icon' />
                  {newObj.AddPkCodeWord[language]}
                </Button>
              </div>
            </div>
            <div className='modal_flexible_btn_ctr'>
              <button
                onClick={() => {
                  handleSubmit(tokens_session, payload);
                }}
              >
                {newObj.SaveWord[language]}
              </button>
            </div>
          </>
        )}
        {step === 3 && (
          <>
            <form
              action='POST'
              className='app_auth_search_form'
              onSubmit={(e) => {
                e.preventDefault();
                searchGetPPPLSAllKawasan(tokens_session, {q: searchKawasan});
              }}
            >
              <div className='app_auth_search_input_wrapper'>
                <input
                  type='text'
                  value={searchKawasan}
                  className='app_auth_search_input'
                  onChange={(e) => setSearchKawasan(e.target.value)}
                />
                <Search className='app_auth_search_icon' />
              </div>
            </form>
            <Grid container className='app_auth_search_selection_wrapper'>
              <CheckBoxPkCodeSelection
                data={kawasanList}
                onSelectionChange={(e, item) =>
                  handleChangeCheckPkCode(e, item)
                }
                payload={payload}
                name='pk_codes'
              />
            </Grid>
            <div className='modal_flexible_btn_ctr'>
              <button
                onClick={() => {
                  setStep(2);
                  setPayload((prev) => ({
                    ...prev,
                    assigned_username: selected.username,
                  }));
                }}
              >
                {newObj.SaveWord[language]}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
